export const GET = "get";
export const POST = "post";
export const PUT = "put";
export const DELETE = "delete";
export const DATA = "data";
export const META_ONLY = "META_ONLY";
export const NO_401_REDIRECT = "NO_401_REDIRECT";
